import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LoadingManager {
  private loadingState$ = new BehaviorSubject<Record<string, boolean>>({});

  public readonly loading$ = this.getLoading$();

  setLoading(key: string, value: boolean): void {
    this.loadingState$.next({ ...this.loadingState$.value, [key]: value });
  }

  isLoading(key: string): boolean {
    return this.loadingState$.value[key] ?? false;
  }

  getLoadingStateDict$(): Observable<Record<string, boolean>> {
    return this.loadingState$.asObservable();
  }

  getLoading$(): Observable<boolean> {
    return this.getLoadingStateDict$().pipe(
      map((dict) => {
        return Object.values(dict).some((value) => value);
      })
    );
  }
}
